import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import withData from '@bd/bdcore-data';
import { css } from '@bd/bdui-styles/emotion';
import { SanitizeHtml, buildThumbnailUrl } from '@bd/bdcore-utilities';
import PageHelmet from '@bd/bdcore-pagehelmet';
import PageWrapper from '../../components/PageWrapper';
import InsideHeader from '../../components/InsideHeader';
import MenuAbout from '../../components/MenuAbout';
import PageIntroBanner from '../../components/PageIntroBanner';
import { colors } from '../../styles';

const styles = css`
    .Process_inner {
      align-items: center;
    }
    .Process {
      padding:20px;

      .Process_header {
        width: 95px;
        height: 95px;
        line-height: 92px;
        text-align: center;
        border: 5px solid ${colors.color2};
        font-size: 31px;
        color: #000000;
        font-weight: 800;
        border-radius: 50%;
      }
      .Process_title {
        color: ${colors.color1};
        font-size: 23px;
        text-transform: uppercase;
        line-height: 36px;
        margin: 0 0 30px 0;
        font-weight: 800;
      }
      .Process_body {
        font-weight: 300;
        font-size: 16px;
        color: #3F3F3F;
        line-height: 30px;
      }
      .Process_media {
        background-image: url('/images/process-fpo.jpg');
        background-size: cover;
        background-position: center center;
        margin-right: 15px;
        height: 400px;
        @media (min-width: 992px) {
          height: auto;
          min-height: 300px;
        }
      }
    }
  main {
    padding:20px 0;
    @media (min-width: 480px) {
      padding:40px 0;
    }
    @media (min-width: 768px) {
      padding:60px 0;
    }
  }
`;

function BuildLot({ page }) {
  return (
    <div className={styles}>
      <PageWrapper>
        <PageHelmet page={page} />
        <InsideHeader
          h1={`${page.meta.name}`}
          background={get(page, 'page_image.contentUrl')}
        />
        <MenuAbout />
        <PageIntroBanner
          heading={get(page, 'page_intro_banner[0].heading')}
          body={get(page, 'page_intro_banner[0].text')}
          image={get(page, 'page_intro_banner[0].image.contentUrl')}
        />
        <main className="container">
          {
            page.process_list.map((item, index) => (
              <div key={item.title} className="Process">
                <div className="Process_wrapper">
                  <div className="Process_inner row">
                    <div className="col-lg-2">
                      <div className="Process_header">{index + 1}</div>
                    </div>
                    <div className="col-lg-4 Process_content">
                      <h4 className="Process_title">
                        {item.title}
                      </h4>
                      <div className="Process_body" dangerouslySetInnerHTML={SanitizeHtml(item.copy)} />
                    </div>
                    <div className="col-lg-5 ml-auto Process_media" style={{ backgroundImage: `url(${buildThumbnailUrl(item.image.contentUrl, { width: 800, height: 800 })})` }} />
                  </div>
                </div>
              </div>
            ))
          }
        </main>
      </PageWrapper>
    </div>
  );
}

BuildLot.propTypes = {
  page: PropTypes.object.isRequired,
};

export default withData({
  page: 'build_on_your_lot',
})(BuildLot);



// WEBPACK FOOTER //
// ./src/pages/BuildLot/index.js